<template>
  <div class="about about-pages">
    <div class="title-container"><h2 class="container">歴史を知る</h2></div>
    <div class="container">
      <photo-and-text v-for="page in pages"
        :key="page.title"
        :title="page.title"
        :text="page.text"
        :imgSrc="page.imgSrc"
        :imgAlt="page.imgAlt"
        :isRightPhoto="page.isRightPhoto"
      ></photo-and-text>
        <photo-line :photos="photos" />
    </div>
  </div>
</template>

<script>
import PhotoAndText from '../../components/PhotoAndText';
import PhotoLine from '../../components/PhotoLine';


export default {
  name: 'history',
  components: {
    PhotoAndText,
    PhotoLine,
  },
  data() {
    return {
      pages: [
        {
          title:"かつうら町のはじまり",
          text:"かつうら町が歴史の表舞台に姿を現すのは比較的新しく、<br>" 
            + "阿淡郡庄志に沼江村の生夷荘と、現在でも見られる地名が書かれたことが始原とされます。<br>" 
            + "平安時代に石清水八幡宮の荘園であったこの土地は、<br>" 
            + "南北朝の動乱により阿波国守護であった細川氏が地頭となりました。" 
            + "<br>細川氏も下剋上にならい、家臣の三好氏に滅ぼされ、荘園は崩壊します。<br><br>" 
            + "その後、土豪たちが自分たちの土地に累柵を立て、<br>" 
            + "荘園を割ったことにより、現在の今山・星谷・中角など<br>" 
            + "集落の基礎が形成されたとされます。",
          imgSrc:"/static/photos/old_photo1.jpg",
          imgAlt:"昔の勝浦町",
          isRightPhoto: true,
        },
        {
        title:"江戸時代",
        text:"阿波藩となった徳島は蜂須賀家政が治め、かつうら町もその領土となります。<br>" 
            + "かつうら町は、勝浦川を使った水運による流送が便利だったこともあり、<br>" 
            + "立川の山林は早くから藩有林となり、徳島城の築城に役立てられるなど、<br>" 
            + "林業が盛んな土地でした。<br>" 
            + "今に名だたる勝浦みかんの始原は、この江戸時代末期にさかのぼります。",
        imgSrc:"/static/photos/old_photo4.jpg",
        imgAlt:"昔の勝浦町",

        },
        {
        title:"明治から現代",
        text:"明治のかつうら町地域には、生比奈村、棚野村、次いで横瀬町が成立し、<br>" 
            + "それぞれに役場が置かれ、経済・行政の中心となりその役を担っていきます。<br>" 
            + "大正時代にはみかんの栽培もいよいよ盛んとなり、かつうら町の産業に<br>" 
            + "大きな影響力を持つようになりました。<br>" 
            + "昭和30年に生比奈村と横瀬町が合併して、かつうら町が誕生します。<br>" 
            + "合併後60年を越えた現在、みかん栽培を基幹産業とし益々の発展が期待されています。",
        imgSrc:"/static/photos/old_photo2.jpg",
        imgAlt:"昔の勝浦町",
        isRightPhoto : true,
        }
      ],
      photos: [
        {img: "/static/photos/old_photo3.jpg", alt: "昔の勝浦町"},
        {img:"/static/photos/old_photo5.jpg", alt: "昔の勝浦町"},
        {img:"/static/photos/old_photo6.jpg", alt:"昔の勝浦町"}
      ],
    
    }
  },
  computed: {  
  }
}

</script>

<style scoped>


h2 {
  text-align: left;
  color: white;
}

.sub_content_img {
  width: 90%;
  object-fit: cover;
  max-height: 400px;
}

</style>
